<div mat-dialog-title>
  @if (data.icon) {
    <div class="title-icon">
      <i [class]="'fa ' + data.icon"></i>
    </div>
  }
  <div class="title-text">{{ data.title | transloco }}</div>
</div>
<mat-dialog-content>
  <p [innerHTML]="data.message | transloco"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.closeButton) {
    <button mat-button mat-dialog-close (click)="close()">
      {{ data.closeButton.text | transloco }}
    </button>
  }
  @if (data.confirmButton) {
    <button mat-button mat-dialog-close  (click)="confirm()">
      {{ data.confirmButton.text | transloco }}
    </button>
  }
</mat-dialog-actions>
